var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { properties, property_id, show_back_to_srp_link, is_next, price_text, srp_header } = options; 
__p+='\n';
 let omtagText = is_next ? "next_modal:listing" : "prev_modal:listing" 
__p+='\n\n';
 if (properties && properties.length) { 
__p+='\n<div class="row mini-srp-header-section">\n  <div class="pull-left header-txt">\n    ';
 if (srp_header) { 
__p+='\n      <h3>\n        '+
((__t=( srp_header ))==null?'':__t)+
'\n      </h3>\n    ';
 } 
__p+='  \n  </div>\n  ';
 if (!MOVE_DATA.isPhone) { 
__p+='\n    <div class="pull-right mini-srp-close">\n      <a href="javascript:void(0)" class="mini-srp-close-icon" id="mini-srp-close-icon">\n        <i class="ra ra-close-thin"></i>\n      </a>\n    </div>\n  ';
 } 
__p+='\n</div>\n\n<div class="component_bm-carousel" id="rdc-carousel-wrapper">\n  <div class="rdc-carousel">\n    <div class="owl-carousel">\n      ';
 properties.forEach((property) => { 
__p+='\n        <div class="listing-card-compact"\n          data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'">\n          <a href="javascript:void(0)"\n            class="bm-link-overlay" data-omtag="for_sale:ldp-quickview:'+
((__t=(omtagText))==null?'':__t)+
'" itemprop="url"></a>\n          <div class="aspect-content compact-card-image-wrapper ">\n            <img data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="compact-card-image" alt="Property Photo">\n            <div class="overlay-text">\n              <div class="card-price">\n               '+
((__t=( property.price ))==null?'':__t)+
'\n              </div>\n              <div class="card-bed second-row">\n                '+
((__t=( property.beds ))==null?'':__t)+
' bed\n              </div>\n              <div class="card-bath second-row">\n                '+
((__t=( property.baths ))==null?'':__t)+
' bath\n              </div>\n            </div>\n            ';
 if (property_id == property.property_id) { 
__p+='\n              <div class="currently-viewing">\n                <span class="currently-viewing-text">Viewing</span>\n              </div>\n            ';
 } 
__p+='\n          </div>\n        </div>\n      ';
 }) 
__p+='\n      ';
 if (show_back_to_srp_link) { 
__p+='\n        <div class="back-to-srp-div">\n          <span class="back-to-srp-msg">Back to results</span>\n        </div>\n      ';
 } 
__p+='\n    </div>\n  </div>\n</div>\n';
 } 
__p+='';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/optimization/qv-mini-srp-carousel.jst.ejs